// eslint-disable-next-line import/prefer-default-export
export const SEARCH_PAYMENT_GENERATED = "[PAYMENT_GENERATED] SEARCH_PAYMENT_GENERATED";
export const GENERATE_MANUAL_PAY = "[PAYMENT_GENERATED] GENERATE_MANUAL_PAY";
export const SEARCH_MANUAL_PAY = "[PAYMENT_GENERATED] SEARCH_MANUAL_PAY";
export const GET_HISTORY_PAYMENT = "[PAYMENT_GENERATED] GET_HISTORY_PAYMENT";
export const PAYMENT_DETAIL_BYID = "[PAYMENT_GENERATED] PAYMENT_DETAIL_BYID";
// export const UPDATE_PAYMENT_ORDER = "[PAYMENT_GENERATED] UPDATE_PAYMENT_ORDER";
